import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import CustomButton from "../common/CustomButton";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import ArrowCircleLeftRoundedIcon from "@mui/icons-material/ArrowCircleLeftRounded";
import CustomTextFeild from "../common/CustomTextFeild";
import { _apiUrls } from "../utils/endpoints/apiUrls";
import { _toastVariants } from "../utils/constants/constants";
import CustomTextArea from "../common/CustomTextArea";
import CustomSelect from "../common/CustomSelect";
import { apiRequest } from "../utils/config/apiRequest";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getTheme } from "../redux/selectors/appSelectors";
// import { validateNotificationForm } from "../common/Validation";
import { validateNotificationForm } from "../common/Validation";
import { compressImageIfNeeded } from "../utils/endpoints/filehelper";
import MapLocationPicker from "./MapLocationPicker";
import MapView from "./MapViewComponent";

export default function AddNotification() {
  const theme = useSelector(getTheme);
  const isDarkMode = theme === "dark";

  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const [showMapPicker, setShowMapPicker] = useState(false);

  const [state, setState] = useState({
    notificationTitle: "",
    startDate: "",
    endDate: "",
    description: "",
    logo: null,
    bannerImage: null,
    mediaFiles: null,
    categoryId: "",
    backgroundColor: "",
    countryName: "",
    latitude: null,
    longitude: null,
    pushNow: true,
    address: "",
    scheduleDate: Date.now(),
  });

  const [load, setLoad] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [errors, setErrors] = useState({});

  const [category, setCategory] = useState({
    row: [],
  });

  const [backgroundColor, setBackgroundColor] = useState({
    row: [],
  });
  const [countryName, setCountry] = useState({
    row: [],
  });

  const getCategory = async () => {
    const { data, status } = await apiRequest({
      endUrl: _apiUrls.getCategory,
      method: "GET",
    });
    if (status) {
      const formatted = data?.rows?.map((item) => ({
        label: item.categoryName,
        value: item._id,
      }));
      setCategory({ row: formatted });
    }
  };

  const getBackgroundColor = async () => {
    const { data, status } = await apiRequest({
      endUrl: _apiUrls.backgroundColor,
      method: "GET",
    });
    if (status) {
      const formatted = data?.rows?.map((item) => ({
        label: item.name,
        value: item._id,
        color: item.name,
      }));
      setBackgroundColor({ row: formatted });
    }
  };

  const getCountry = async () => {
    const { data, status } = await apiRequest({
      endUrl: _apiUrls.fetchCountry,
      method: "GET",
    });
    if (status) {
      const formatted = data?.rows?.map((item) => ({
        label: item.name,
        value: item.name,
      }));
      setCountry({ row: formatted });
    }
  };

  const handleSelectChange = (selected) => {
    setState((prev) => ({
      ...prev,
      categoryId: selected?.value || "",
    }));
  };

  const handleLocationSelect = (location) => {
    setState((prev) => ({
      ...prev,
      latitude: location.lat,
      longitude: location.lng,
    }));
  };

  const handleFileChange = (e, field) => {
    setState((prev) => ({ ...prev, [field]: e.target.files[0] }));
  };

  // Add Edit -------------------------------------------------

  const getNotificationDetails = async () => {
    setLoadingData(true);
    const { data, status } = await apiRequest({
      endUrl: _apiUrls.getNotification,
      method: "GET",
      query: { notificationId: id },
    });
    setLoadingData(false);
    const notificationData = Array.isArray(data?.rows)
      ? data.rows.find((item) => item._id === id)
      : data;
    if (status && notificationData) {
      setState({
        notificationTitle: notificationData?.notificationTitle,
        startDate: notificationData?.startDate?.slice(0, 10),
        endDate: notificationData?.endDate?.slice(0, 10),
        description: notificationData?.description,
        address: notificationData?.address,
        logo: notificationData?.logo,
        bannerImage: notificationData?.bannerImage,
        mediaFiles: notificationData?.mediaImage,
        categoryId: notificationData?.categoryId?._id,
        backgroundColor: notificationData?.background?._id,
        countryName: notificationData?.countryName,
        scheduleDate: notificationData?.scheduleDate?.slice(0, 10),

        latitude: notificationData?.latitude,
        longitude: notificationData?.longitude,
      });
    } else {
      console.warn("Notification not found or status false:");
    }
  };


  const handlePublish = async () => {
    const validationErrors = validateNotificationForm(state, isEditMode);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    const compressedLogo = await compressImageIfNeeded(state?.logo);
    const compressedBanner = await compressImageIfNeeded(state?.bannerImage);
    const compressedMedia = await compressImageIfNeeded(state?.mediaFiles);

    setLoad(true);
    const formData = new FormData();
    formData.append("notificationTitle", state?.notificationTitle);
    formData.append("startDate", state?.startDate);
    formData.append("endDate", state?.endDate);
    formData.append("description", state?.description);
    formData.append("logo", compressedLogo);
    formData.append("bannerImage", compressedBanner);
    formData.append("mediaImage", compressedMedia);
    formData.append("categoryId", state?.categoryId);
    formData.append("backgroundColor", state?.backgroundColor);
    formData.append("countryName", state?.countryName);
    formData.append("scheduleDate", state?.scheduleDate);
    formData.append("address", state?.address);

    formData.append("latitude", state?.latitude);
    formData.append("longitude", state?.longitude);
    formData.append("pushNow", state?.pushNow);

    const { status } = await apiRequest({
      endUrl: isEditMode
        ? _apiUrls.updateNotification
        : _apiUrls.addNotification,
      method: isEditMode ? "PUT" : "POST",
      body: formData,
      headerType: "form",
      query: isEditMode ? { notificationId: id } : {},
      showMsg: true,
    });
    setLoad(false);
    if (status) {
      navigate("/dashboard/notifications");
    }
  };

  useEffect(() => {
    getCategory();
    getBackgroundColor();
    getCountry();

    if (isEditMode) {
      getNotificationDetails();
    }
  }, [id]);

  return (
    <>
      {loadingData ? (
        <tr>
          <td colSpan="7" className="text-center py-4">
            <div className="d-flex justify-content-center align-items-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </td>
        </tr>
      ) : (
        <>
          <Row className="align-items-start">
            <Col md={8} className="py-1">
              <h4 className="dashheading">Add Notification</h4>
              <p className="dashsubheading">Add/Edit Notification</p>
            </Col>
            <Col md={4} className="py-1">
              <div className="d-flex justify-content-end align-items-center gap-2">
                <CustomButton
                  variant="contained"
                  text={
                    load ? <Spinner size="sm" animation="border" /> : "Publish"
                  }
                  iconLeft={<CheckBoxOutlinedIcon style={{ fontSize: 18 }} />}
                  className="containebtn"
                  style={{ width: 100 }}
                  onClick={handlePublish}
                />
                <CustomButton
                  variant="outline3"
                  text={"Cancel"}
                  iconLeft={
                    <ArrowCircleLeftRoundedIcon
                      style={{
                        fontSize: 18,
                        color: isDarkMode ? "#fff" : "#fff",
                      }}
                    />
                  }
                  className="outline-btn"
                  onClick={() => navigate("/dashboard/notifications")}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={8} className="py-1">
              <Row>
                <Col md={12} className="pb-3">
                  <p className="mb-1 input-label head-border">
                    Enter the details below for create/edit Notification
                  </p>
                </Col>

                <Col md={6}>
                  <p className="mb-1 input-label">
                    Notification Title <span style={{ color: "red" }}>*</span>
                  </p>
                  <CustomTextFeild
                    style={{
                      padding: "9px 11px",
                      borderRadius: "10px",
                    }}
                    placeholder="Enter Notification Title"
                    value={state?.notificationTitle}
                    onChange={(e) =>
                      setState((prev) => ({
                        ...prev,
                        notificationTitle: e.target.value,
                      }))
                    }
                  />
                  {errors.notificationTitle && (
                    <p className="errormsg mt-1">{errors.notificationTitle}</p>
                  )}
                </Col>
                <Col md={6}>
                  <p className="mb-1 input-label">
                    Select Category <span style={{ color: "red" }}>*</span>
                  </p>
                  <CustomSelect
                    className="custom-select"
                    placeholder="Select Category"
                    style={{ padding: "9px 11px", marginBottom: 0 }}
                    options={category.row}
                    onChange={handleSelectChange}
                    value={
                      category.row.find(
                        (option) => option.value === state.categoryId
                      )?.value || ""
                    }
                  />
                  {errors.categoryId && (
                    <p className="errormsg mt-1">{errors.categoryId}</p>
                  )}
                </Col>
                <Col md={6}>
                  <p className="mb-1 input-label">
                    Select Country<span style={{ color: "red" }}>*</span>
                  </p>
                  <CustomSelect
                    className="custom-select"
                    placeholder="Select Country"
                    style={{ padding: "9px 11px", marginBottom: 0 }}
                    options={countryName.row}
                    onChange={(selected) =>
                      setState((prev) => ({
                        ...prev,
                        countryName: selected?.value || "",
                      }))
                    }
                    value={
                      countryName.row.find(
                        (option) => option.value === state.countryName
                      )?.value || ""
                    }
                  />
                  {errors.countryName && (
                    <p className="errormsg mt-1">{errors.countryName}</p>
                  )}
                </Col>
                <Col md={6}>
                  <p className="mb-1 input-label">
                    Select Background <span style={{ color: "red" }}>*</span>
                  </p>
                  <CustomSelect
                    className="custom-select"
                    placeholder="Select Background"
                    style={{ padding: "9px 11px", marginBottom: 0 }}
                    options={backgroundColor.row}
                    value={state.backgroundColor}
                    onChange={(selected) =>
                      setState((prev) => ({
                        ...prev,
                        backgroundColor: selected?.value || "",
                      }))
                    }
                    showColorCircle // ✅ enables color preview only here
                  />

                  {errors.backgroundColor && (
                    <p className="errormsg mt-1">{errors.backgroundColor}</p>
                  )}
                </Col>
                <Col md={6} className="mt-2">
                  <p className="mb-1 input-label">
                    Start Date. <span style={{ color: "red" }}>*</span>
                  </p>
                  <CustomTextFeild
                    style={{
                      padding: "9px 11px",
                      borderRadius: "10px",
                    }}
                    type="date"
                    value={state?.startDate}
                    onChange={(e) =>
                      setState((prev) => ({
                        ...prev,
                        startDate: e.target.value,
                      }))
                    }
                  />
                  {errors.startDate && (
                    <p className="errormsg mt-1">{errors.startDate}</p>
                  )}
                </Col>

                <Col md={6} className="mt-2">
                  <p className="mb-1 input-label">
                    End Date <span style={{ color: "red" }}>*</span>
                  </p>
                  <CustomTextFeild
                    style={{
                      padding: "9px 11px",
                      borderRadius: "10px",
                    }}
                    type="date"
                    min={state.startDate || ""}
                    value={state?.endDate}
                    onChange={(e) =>
                      setState((prev) => ({ ...prev, endDate: e.target.value }))
                    }
                  />
                  {errors.endDate && (
                    <p className="errormsg mt-1">{errors.endDate}</p>
                  )}
                </Col>

                <Col md={6} className="mt-3">
                  <p className="mb-1 input-label">
                    Latitude <span style={{ color: "red" }}>*</span>
                  </p>
                  <CustomTextFeild
                    style={{
                      padding: "9px 11px",
                      borderRadius: "10px",
                    }}
                    placeholder="Latitude"
                    type="number"
                    value={state?.latitude}
                    onChange={(e) =>
                      setState({ ...state, latitude: e.target.value })
                    }
                  />
                  {errors.latitude && (
                    <p className="errormsg mt-1">{errors.latitude}</p>
                  )}
                </Col>

                <Col md={6} className="mt-3">
                  <p className="mb-1 input-label">
                    Longitude <span style={{ color: "red" }}>*</span>
                  </p>
                  <CustomTextFeild
                    style={{
                      padding: "9px 11px",
                      borderRadius: "10px",
                    }}
                    placeholder="Longitude"
                    type="number"
                    value={state?.longitude}
                    onChange={(e) =>
                      setState({ ...state, longitude: e.target.value })
                    }
                  />
                  {errors.longitude && (
                    <p className="errormsg mt-1">{errors.longitude}</p>
                  )}
                </Col>
                <Col md={12} className="mt-3">
                  <CustomButton
                    variant="outline"
                    text={"Fetch Location"}
                    className="outline-btn"
                    onClick={() => setShowMapPicker(true)}
                  />
                </Col>

                <Col md={6} className="mt-3">
                  <p className="mb-1 input-label">
                    Description <span style={{ color: "red" }}>*</span>
                  </p>
                  <CustomTextArea
                    placeholder="Enter Message"
                    value={state?.description}
                    onChange={(e) =>
                      setState((prev) => ({
                        ...prev,
                        description: e.target.value,
                      }))
                    }
                  />
                  {errors.description && (
                    <p className="errormsg mt-1">{errors.description}</p>
                  )}
                </Col>
                <Col md={6} className="mt-3">
                  <p className="mb-1 input-label">
                    Address<span style={{ color: "red" }}>*</span>
                  </p>
                  <CustomTextArea
                    placeholder="Enter Address"
                    value={state?.address}
                    onChange={(e) =>
                      setState((prev) => ({ ...prev, address: e.target.value }))
                    }
                  />
                  {errors.address && (
                    <p className="errormsg mt-1">{errors.address}</p>
                  )}
                </Col>

                <Col md={12} className="mt-2">
                  <div
                    key={1}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                      minWidth: "200px", // ensures at least two side-by-side
                    }}
                    className="status-option mb-3 mt-2"
                  >
                    <input
                      type="checkbox"
                      checked={!state.pushNow}
                      onChange={() =>
                        setState((prev) => ({
                          ...prev,
                          scheduleDate: Date.now(),
                          pushNow: !state.pushNow,
                        }))
                      }
                    />
                    <p className="mb-0"> Schedule Notification</p>
                  </div>
                </Col>

                {!state.pushNow && (
                  <Col md={6} className="mt-2">
                    <p className="mb-1 input-label">
                      Schedule Date. <span style={{ color: "red" }}>*</span>
                    </p>
                    <CustomTextFeild
                      style={{
                        padding: "9px 11px",
                        borderRadius: "10px",
                      }}
                      type="date"
                      value={state?.scheduleDate}
                      onChange={(e) =>
                        setState((prev) => ({
                          ...prev,
                          scheduleDate: e.target.value,
                        }))
                      }
                    />
                    {errors.scheduleDate && (
                      <p className="errormsg mt-1">{errors.scheduleDate}</p>
                    )}
                  </Col>
                )}
              </Row>

              <Row>
                <Col md={6} className="mt-3">
                  <p className="mb-1 input-label">
                    Add logo <span style={{ color: "red" }}>*</span>
                  </p>
                  <Form.Group controlId="formFile">
                    <Form.Control
                      type="file"
                      style={{
                        padding: "8px 12px",
                        border: "1px solid #ccc",
                        borderRadius: "10px",
                      }}
                      className="fileInput"
                      onChange={(e) => handleFileChange(e, "logo")}
                    />
                    {errors.logo && (
                      <p className="errormsg mt-1">{errors.logo}</p>
                    )}
                    {isEditMode && state?.logo && (
                      <div className="mt-3">
                        <img
                          src={
                            state?.logo instanceof File
                              ? URL.createObjectURL(state.logo)
                              : `${process.env.REACT_APP_API_ORIGIN}/${state?.logo?.replace(/^\/+/, "")}`
                          }

                          alt=""
                          style={{
                            width: 100,
                            height: 100,
                            borderRadius: "10px",
                            objectFit: "cover",
                            border: "1px solid #ddd",
                          }}
                        />
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} className="mt-3">
                  <p className="mb-1 input-label">
                    Add Banner image <span style={{ color: "red" }}>*</span>
                  </p>
                  <Form.Group controlId="formFile">
                    <Form.Control
                      type="file"
                      style={{
                        padding: "8px 12px",
                        border: "1px solid #ccc",
                        borderRadius: "10px",
                      }}
                      className="fileInput"
                      onChange={(e) => handleFileChange(e, "bannerImage")}
                    />
                    {errors.bannerImage && (
                      <p className="errormsg mt-1">{errors.bannerImage}</p>
                    )}
                    {isEditMode && state?.bannerImage && (
                      <div className="mt-3">
                        <img
                          src={
                            state?.bannerImage instanceof File
                              ? URL.createObjectURL(state.bannerImage)
                              : `${process.env.REACT_APP_API_ORIGIN}/${state?.bannerImage?.replace(/^\/+/, "")}`
                          }

                          alt=""
                          style={{
                            width: 100,
                            height: 100,
                            borderRadius: "10px",
                            objectFit: "cover",
                            border: "1px solid #ddd",
                          }}
                        />
                      </div>
                    )}
                  </Form.Group>
                </Col>

                {/* <Col md={6} className='mt-3'>
                            <p className='mb-1 input-label'>Add Media files <span style={{ color: 'red' }}>*</span></p>
                            <Form.Group controlId="formFile">
                                <Form.Control
                                    type="file"
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #ccc',
                                        borderRadius: '10px',
                                    }}
                                    className='fileInput'
                                    onChange={(e) => handleFileChange(e, 'mediaFiles')}
                                />
                                {errors.mediaFiles && <p className='errormsg mt-1'>{errors.mediaFiles}</p>}
                                {isEditMode && state.mediaFiles && (
                                    <div className="mt-3">
                                        <img
                                            src={
                                                state?.mediaFiles instanceof File
                                                    ? URL.createObjectURL(state?.mediaFiles)
                                                    : `${process.env.REACT_APP_API_BASE_URL?.replace('/api', '')}${state?.mediaFiles?.startsWith('/') ? '' : '/'}${state?.mediaFiles}`
                                            }
                                            alt=""
                                            style={{
                                                width: 100,
                                                height: 100,
                                                borderRadius: '10px',
                                                objectFit: 'cover',
                                                border: '1px solid #ddd'
                                            }}
                                        />
                                    </div>
                                )}
                            </Form.Group>
                        </Col> */}
              </Row>
            </Col>
            {state.latitude && state.longitude && (
              <Col md={4} className="py-1">
                <div className="mb-3">
                  <p className="mb-2 input-label head-border">
                    Location Preview
                  </p>
                  <MapView
                    latitude={state.latitude}
                    longitude={state.longitude}
                  />
                  <div
                    className="mt-2 p-2"
                    style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}
                  >
                    <small className="text-muted d-block">
                      <strong>Coordinates:</strong>
                    </small>
                    <small className="text-muted">
                      Lat: {parseFloat(state.latitude).toFixed(6)}, Lng:{" "}
                      {parseFloat(state.longitude).toFixed(6)}
                    </small>
                  </div>
                </div>
              </Col>
            )}
          </Row>

          <MapLocationPicker
            isOpen={showMapPicker}
            onClose={() => setShowMapPicker(false)}
            onLocationSelect={handleLocationSelect}
            initialLat={state.latitude}
            initialLng={state.longitude}
            title="Select Notification Location"
          />
        </>
      )}
    </>
  );
}
